<template>
  <div class="dashboard-component">
    <splitpanes>
      <pane>
        <!-- Sidenav -->
        <a
          href="#"
          v-if="navPlacement === 'sidebar' && isDataLoaded"
          class="sidebarMobileTrigger"
          @click.prevent="showSidebar"
        >
          <icon name="bars" />
        </a>
        <side-bar
          v-if="navPlacement === 'sidebar' && isDataLoaded"
          :logoImg="settings.logoImgSource ? settings.logoImgSource : logoImg"
          logoLink="/home"
          ref="sidebar"
          v-click-outside="hideSidebar"
        >
          <div class="navbar-inner">
            <!-- Nav items -->

            <!-- Default App Nav --- START -->

            <h6 class="navbar-heading p-0 text-white">{{ dashTitle }}</h6>
            <ul class="navbar-nav">
              <Tabs
                :navPlacement="navPlacement"
                v-for="tab in prepareTabs(tabs)"
                :key="tab.key"
                :tab="tab"
                :tabKey="tab.key"
                :subTabs="subTabs"
                @setCurrentTab="setCurrentTab"
                @showTabContextMenu="showTabContextMenu"
                @setCurrentSubTab="setCurrentSubTab"
                @showSubTabContextMenu="showSubTabContextMenu"
                @addNewSubTab="addNewSubTab"
              />
              <li class="nav-item">
                <a href="#" class="nav-link" @click.prevent="addNewTab">
                  <i class="ni ni-fat-add text-white"></i>
                  <span class="nav-link-text">Add Page</span>
                </a>
              </li>
            </ul>
            <!-- Default App Nav --- END -->

            <!-- Inherited Apps Nav --- START -->
            <div v-for="template in selectedTemplates" :key="template">
              <hr class="my-3" />
              <h6 class="navbar-heading p-0 text-white">{{ inheritedData[template].name }}</h6>
              <ul class="navbar-nav">
                <Tabs
                  :navPlacement="navPlacement"
                  v-for="tab in prepareTabs(tabs, template)"
                  :key="tab.key"
                  :tab="tab"
                  :tabKey="tab.key"
                  :subTabs="subTabs"
                  @setCurrentTab="setCurrentTab"
                  @showTabContextMenu="showTabContextMenu"
                  @setCurrentSubTab="setCurrentSubTab"
                  @showSubTabContextMenu="showSubTabContextMenu"
                  @addNewSubTab="addNewSubTab"
                />
                <li class="nav-item">
                  <a href="#" class="nav-link" @click.prevent="addNewTab($event, template)">
                    <i class="ni ni-fat-add text-white"></i>
                    <span class="nav-link-text">Add Page</span>
                  </a>
                </li>
              </ul>
            </div>
            <!-- Inherited Apps Nav --- END -->

            <!-- Inherit Trigger -->
            <div v-if="ableToAddApp">
              <hr class="my-3" />
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a href="#" class="nav-link" @click.prevent="$refs.addAppModal.open()">
                    <i class="ni ni-fat-add text-white"></i>
                    <span class="nav-link-text">Add App</span>
                  </a>
                </li>
              </ul>
            </div>

            <!-- Core App Nav --- START -->
            <div v-if="currentDash !== 'core'">
              <hr class="my-3" />
              <h6 class="navbar-heading p-0 text-white">Tangle Options</h6>
              <ul class="navbar-nav" style="padding-bottom: 15px;">
                <Tabs
                  :navPlacement="navPlacement"
                  v-for="tab in prepareTabs(tabs, 'core')"
                  :key="tab.key"
                  :tab="tab"
                  :tabKey="tab.key"
                  :subTabs="subTabs"
                  @setCurrentTab="setCurrentTab"
                  @showTabContextMenu="showTabContextMenu"
                  @setCurrentSubTab="setCurrentSubTab"
                  @showSubTabContextMenu="showSubTabContextMenu"
                  @addNewSubTab="addNewSubTab"
                />
              </ul>
            </div>
            <!-- Core App Nav --- END -->
          </div>
        </side-bar>

        <div
          class="dashboard__wrapper"
          :class="{ 'main-content _navInSideBar': navPlacement === 'sidebar' }"
          id="panel"
        >
          <NavBar
            :dashTitle="dashTitle"
            :navPlacement="navPlacement"
            :isDataLoaded="isDataLoaded"
            :class="{ _navInSideBar: navPlacement === 'sidebar' }"
          >
            <template v-if="navPlacement === 'navbar'" v-slot:tabsMenu>
              <div class="tabs-menu">
                <div class="tabs-menu__mobile"></div>
                <ul class="tabs-menu__list">
                  <li v-for="tab in prepareTabs(tabs)" :key="tab.key" class="tabs-menu__item">
                    <a
                      href="#"
                      @click.prevent="setCurrentTab(tab.key)"
                      class="tabs-menu__link"
                      :class="{ _active: tab.key === currentTab }"
                    >
                      <span v-if="tab" :data-tab="tab.key" @keydown.stop>{{ tab.title }}</span>
                      <span
                        v-if="$canUpdate"
                        class="tabs-menu__editTabTrigger"
                        @click.prevent.stop="showTabContextMenu($event)"
                      >
                        <icon name="ellipsis-v" style="vertical-align: -4px;" />
                      </span>
                    </a>
                  </li>
                  <li v-if="$canUpdate" class="tabs-menu__item _new">
                    <a href="#" @click.prevent="addNewTab" class="tabs-menu__link">
                      <icon name="plus" style="vertical-align: -4px;" />
                    </a>
                  </li>
                </ul>
              </div>
            </template>
            <template v-slot:toolbar>
              <div class="navbar-toolbar">
                <div class="navbar-toolbar__subtabs-nav">
                  <ul v-if="hasSubTabs && navPlacement === 'navbar'" class="subtabs-nav">
                    <li
                      v-for="(subTab, subTabKey) in subTabs[currentTab]"
                      :key="subTabKey"
                      class="subtabs-nav__item"
                      :class="{ _active: currentSubTab === subTabKey }"
                    >
                      <a
                        href="#"
                        @click.prevent="setCurrentSubTab(subTabKey)"
                        class="subtabs-nav__link"
                      >
                        {{ subTab.title }}
                        <span
                          v-if="$canUpdate && currentSubTab === subTabKey"
                          class="subtabs-nav__editTabTrigger"
                          @click.prevent.stop="showSubTabContextMenu($event)"
                        >
                          <icon name="ellipsis-v" style="vertical-align: -2px;" scale=".8" />
                        </span>
                      </a>
                    </li>
                    <li v-if="$canUpdate" class="subtabs-nav__item">
                      <a href="#" class="subtabs-nav__link" @click.prevent="addNewSubTab">
                        <icon name="plus" scale=".8" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </NavBar>
          <div class="dashboard" :class="{ _navInSideBar: navPlacement === 'sidebar' }">
            <div v-if="isDataLoaded" class="dashboard__content">
              <div v-if="!additionalView">
                <b-tabs v-if="tabs" v-model="tabIndex" class="dashboard__tabs" no-nav-style lazy>
                  <div v-if="$count(customCodeHtmlReady)">
                    <DynamicRender
                      v-for="(html, idx) in customCodeHtmlReady"
                      :key="idx"
                      :template="html.code"
                      :data="widgetsData"
                      :computed="widgetsComputedReady"
                    />
                  </div>

                  <b-tab v-for="tab in tabs" :key="tab.key">
                    <b-tabs
                      no-nav-style
                      lazy
                      v-if="hasSubTabs && $route.query.subtab"
                      v-model="subTabIndex"
                      class="dashboard__subTabs"
                    >
                      <b-tab
                        v-for="(subTab, subTabKey) in subTabs[tab.key]"
                        :key="subTabKey"
                        :title="subTab.title"
                      >
                        <div v-if="tab.key === currentTab && subTabKey === currentSubTab">
                          <Grid
                            :widgets="widgets"
                            :tabs="tabs"
                            :widgetsData="widgetsData"
                            :widgetsComputed="widgetsComputedReady"
                          />
                        </div>
                      </b-tab>
                    </b-tabs>
                    <Grid
                      v-else
                      :widgets="widgets"
                      :tabs="tabs"
                      :widgetsData="widgetsData"
                      :widgetsComputed="widgetsComputedReady"
                    />
                  </b-tab>
                </b-tabs>
              </div>
              <div v-else class="dashboard__additionalView">
                <SimpleWorkflow v-if="additionalView === 'simpleWorkflow'" />
                <div v-if="additionalView === 'workflow'" style="width: inherit; overflow: hidden;">
                  <Workflow ref="workflow" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </pane>
      <pane
        style="background-color: white; overflow: auto; height: 100vh;"
        v-if="toolsPanel_isOpened"
        size="20"
        min-size="20"
        max-size="50"
        :key="1"
      >
        <ToolsPanel />
      </pane>
    </splitpanes>
    <div v-if="isDataLoaded" class="dashboard__controls">
      <!-- Draggable Editors -->
      <div>
        <WidgetsEdit :widgets="widgets" />
        <ComputedPropEdit :props="widgetsComputed" />
        <CustomCodeEdit :codeBase="customCode" />
        <div class="draggableContainer">
          <keep-alive>
            <CustomCodeSearch
              v-for="(code, key) in customCodeReady"
              :key="key"
              :type="key"
              :code="code"
            />
          </keep-alive>
        </div>
      </div>
      <!-- /Draggable Editors -->

      <CustomCodeRender
        v-if="markupMounted"
        :customCode="customCode"
        :scope="currentTab"
        :widgetsData="widgetsData"
        :widgetsComputed="widgetsComputedReady"
      />
      <!-- Modals -->
      <AddWidgetModal :widgetsComputed="widgetsComputedReady" />
      <NewSheetModal />
      <ShareDashboardModal />
      <PivotTableModal />
      <PostsWidgetModal />
      <CustomCodeModal />
      <CustomCodeUpdateModal />
      <AddDataWidgetModal />
      <AddChartModal />
      <AddGanttChartModal />
      <AddGanntSimpleModal />
      <AddTipTapModal />
      <InviteNewUserModal v-if="$canManageUsers || $isAdmin" />
      <DashboardACModal v-if="$canManageUsers || $isAdmin" />
      <DataTreePickerModal />
      <AddFullCalendarModal />
      <AddTabModal ref="addTabModal" :tabs="tabs" @onTabAdded="onTabAdded" />
      <ImportDataGridFromExcelModal />
      <AddDataGridEditRowForm />
      <DataGridEditRowModal ref="dgEditRowModal" />
      <DataGridEditFormDataModal v-if="$canUpdate" />
      <AddSubTabModal :subTabs="subTabs" @onSubTabAdded="onSubTabAdded" />
      <WidgetTabSelectModal />
      <Chat />
      <AddAppModal
        ref="addAppModal"
        :templates="templateDashboardsList"
        :selected="selectedTemplates"
      />
      <TabIconModal :tabs="tabs" />
      <!-- /Modals -->
      <TabContextMenu
        :visible="isTabContextMenuVisible"
        :position="tabContextMenuPosition"
        :tabs="tabs"
        :privateTabs="privateTabs"
        :tabOnLoad="tabOnLoad"
        :hasSubTabs="hasSubTabs"
        @close="isTabContextMenuVisible = false"
        @delete="setCurrentTab"
      />
      <SubTabContextMenu
        v-if="hasSubTabs"
        :visible="isSubTabContextMenuVisible"
        :position="subTabContextMenuPosition"
        :tabs="tabs"
        :subTabs="subTabs"
        @close="isSubTabContextMenuVisible = false"
        @delete="setCurrentSubTab"
      />
      <DataSelect ref="ctxMenuDataSelect" />
      <PropsEditor />
      <DynamicRender
        v-if="onDGCellValueChangeCode"
        :template="onDGCellValueChangeCode"
        :data="widgetsData"
        :computed="widgetsComputedReady"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { maxBy, toArray, find, findIndex } from 'lodash'
// components
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import Grid from './components/Grid'
import ContextMenu from '@/components/ContextMenu'
import WidgetsEdit from '@/components/WidgetsEdit'
import ComputedPropEdit from '@/components/ComputedPropEdit'
import CustomCodeEdit from '@/components/CustomCodeEdit'
import CustomCodeRender from '@/components/CustomCodeRender'
import DynamicRender from '@/components/DynamicRender'
import CustomCodeSearch from '@/components/CustomCodeSearch'
import TabContextMenu from './components/TabContextMenu'
import SubTabContextMenu from './components/SubTabContextMenu'
import ToolsPanel from './components/ToolsPanel'
import DataSelect from './components/DataSelect'
import PropsEditor from './components/PropsEditor'
import Chat from '@/components/BeautifulChat/Chat'
import Tabs from './components/Tabs'
// additional view
import SimpleWorkflow from '@/components/SimpleWorkflow'
import Workflow from './components/additional-view/Workflow'
// modals
import AddWidgetModal from '@/components/Modals/AddWidget'
import NewSheetModal from '@/components/Modals/NewSheet'
import ShareDashboardModal from '@/components/Modals/ShareDashboard'
import PivotTableModal from '@/components/Modals/PivotTable'
import PostsWidgetModal from '@/components/Modals/PostsWidget'
import CustomCodeModal from '@/components/Modals/CustomCode'
import CustomCodeUpdateModal from '@/components/Modals/CustomCodeUpdate'
import AddDataWidgetModal from '@/components/Modals/AddDataWidget'
import AddChartModal from '@/components/Modals/AddChart'
import AddGanttChartModal from '@/components/Modals/AddGanttChartModal'
import AddGanntSimpleModal from '@/components/Modals/AddGanntSimpleModal'
import AddTipTapModal from '@/components/Modals/AddTipTapModal'
import InviteNewUserModal from '@/components/Modals/InviteNewUser'
import DashboardACModal from '@/components/Modals/DashboardAC'
import DataTreePickerModal from '@/components/Modals/DataTreePicker'
import AddFullCalendarModal from '@/components/Modals/AddFullCalendar'
import AddTabModal from './modals/AddTab'
import ImportDataGridFromExcelModal from '@/components/Modals/ImportDataGridFromExcel'
import AddDataGridEditRowForm from './modals/DataGrid/AddEditRowForm'
import DataGridEditRowModal from './modals/DataGrid/EditRow'
import DataGridEditFormDataModal from './modals/DataGrid/EditFormData'
import AddSubTabModal from './modals/AddSubTab'
import WidgetTabSelectModal from './modals/WidgetTabSelect'
import AddAppModal from './modals/AddApp'
import TabIconModal from './modals/TabIcon'
// modules
import FormulaCaching from '@/components/Spreadsheet/FormulaCaching'
// services
import db from '@/services/db'
import storage from '@/services/storage'
import user from '@/services/user'
// helpers
import eventBus from '@/helpers/event-bus'
// hooks
import createdHook from './hooks/created'
import beforeDestroyHook from './hooks/beforeDestroy'

let $ = window.$

export default {
  components: {
    Splitpanes,
    Pane,
    Grid,
    ContextMenu,
    WidgetsEdit,
    ComputedPropEdit,
    CustomCodeEdit,
    CustomCodeRender,
    DynamicRender,
    CustomCodeSearch,
    TabContextMenu,
    SubTabContextMenu,
    ToolsPanel,
    DataSelect,
    PropsEditor,
    Tabs,
    SimpleWorkflow,
    Workflow,
    // modals
    AddWidgetModal,
    NewSheetModal,
    ShareDashboardModal,
    PivotTableModal,
    PostsWidgetModal,
    CustomCodeModal,
    CustomCodeUpdateModal,
    AddDataWidgetModal,
    AddChartModal,
    AddGanttChartModal,
    AddGanntSimpleModal,
    AddTipTapModal,
    InviteNewUserModal,
    DashboardACModal,
    DataTreePickerModal,
    AddFullCalendarModal,
    AddTabModal,
    ImportDataGridFromExcelModal,
    AddDataGridEditRowForm,
    DataGridEditRowModal,
    DataGridEditFormDataModal,
    AddSubTabModal,
    WidgetTabSelectModal,
    Chat,
    AddAppModal,
    TabIconModal,
  },
  data() {
    return {
      isPublic: false,
      dashTitle: null,
      tabs: null,
      subTabs: null,
      widgets: null,
      widgetsData: null,
      widgetsComputed: null,
      customCode: null,
      isDataLoaded: false,
      isTabContextMenuVisible: false,
      isComponentsMenuOpen: false,
      tabContextMenuPosition: {
        x: 0,
        y: 0,
      },
      isSubTabContextMenuVisible: false,
      subTabContextMenuPosition: {
        x: 0,
        y: 0,
      },
      markupMounted: false,
      tabIndex: 0,
      subTabIndex: 0,
      tabOnLoad: null,
      codeSearchShown: {
        js: false,
        css: false,
        html: false,
      },
      privateTabs: [],
      navPlacement: null,
      onDGCellValueChangeCode: null,
      acceptDataGridLogs: false,
      templateDashboardsList: [],
      selectedTemplates: [],
      inheritedData: {},
      additionalView: null,
    }
  },
  watch: {
    dataGrid_options: {
      deep: true,
      handler() {
        this.$dataGridParse(this.$store.state)
      },
    },
    isDataLoaded(val) {
      if (!val) return

      this.$dataGridParse(this.$store.state)
      this.acceptDataGridLogs = true
      this.defineFBUser()

      setTimeout(() => {
        this.markupMounted = true
        this.$store.commit('setDashboardLoadingStatus', false)
      }, 600)
    },
    currentTab(val) {
      if (!val) this.$router.push('/home')
    },
    currentDash(val) {
      if (!val) this.$router.push('/home')
    },
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab',
      'currentDash',
      'userId',
      '$profile',
      'isNFLApp',
      'models_dashboardModel',
      'dataGrid_options',
      'workspaceAccess',
      'userList',
      'settings',
      'toolsPanel_isOpened',
      'files',
      'customComponents',
      'templateDashboards',
    ]),
    widgetsComputedReady() {
      let computed = {}

      for (let key in this.widgetsComputed) {
        if (!this.widgetsComputed[key]) continue
        try {
          computed[key] = new Function(this.widgetsComputed[key]) // eslint-disable-line no-new-func
        } catch (err) {
          console.error(`[Computed] - error in computed property "${key}"`)
        }
      }

      return computed
    },
    customCodeReady() {
      const customCodeReady = {}

      for (let key in this.customCode) {
        if (!this.codeSearchShown[key]) continue
        customCodeReady[key] = this.customCode[key]
      }

      return customCodeReady
    },
    customCodeHtmlReady() {
      const customCodeHtmlReady = {}

      for (let idx in this.customCode.html) {
        const html = this.customCode.html[idx]

        if (!html.scope || html.scope === this.currentTab) {
          customCodeHtmlReady[idx] = html
        }
      }

      return customCodeHtmlReady
    },
    hasSubTabs() {
      if (!this.subTabs) return false
      if (!this.subTabs[this.currentTab]) return false
      return true
    },
    logoImg() {
      return require('@/assets/imgs/logo.png')
    },
    ableToAddApp() {
      // is core dashboard
      if (this.currentDash === 'core') return false

      // if templates list is empty
      if (!this.templateDashboardsList.length) return false

      // if selected all available templates
      let selectedAll = true

      for (let template of this.templateDashboardsList) {
        if (!this.selectedTemplates.includes(template)) selectedAll = false
      }

      if (selectedAll) return false

      return true
    },
    $isAdmin() {
      return this.$can ? this.$can('all', 'Admin') : false
    },
    $canUpdate() {
      return this.$can
        ? this.$can('update', 'Dashboard_' + this.currentDash)
        : false
    },
    $canManageUsers() {
      return this.$can
        ? this.$can('manageUsers', 'Dashboard_' + this.currentDash)
        : false
    },
  },
  methods: {
    prepareTabs(tabs, template) {
      const tabsReady = []

      for (let tab of tabs) {
        if (template) {
          if (tab.template !== template) continue
        } else {
          if (tab.template) continue
        }

        if (
          !~this.privateTabs.indexOf(tab.key) ||
          this.$canUpdate ||
          this.$canManageUsers
        ) {
          tabsReady.push(tab)
        }
      }

      return tabsReady
    },
    getFirstAvailableTab() {
      for (let tab of this.tabs) {
        if (tab.inherited) continue
        if (this.$canUpdate || !this.privateTabs.includes(tab.key))
          return tab.key
      }
      return null
    },
    setInitialTab() {
      const routeTab = this.$route.query.tab
      let tabToSet
      const query = {
        ...this.$route.query,
      }

      if (routeTab) {
        if (
          this.tabs[routeTab] &&
          (this.$canUpdate || !this.privateTabs.includes(routeTab))
        )
          tabToSet = routeTab
        else tabToSet = this.getFirstAvailableTab()
      } else {
        if (this.tabOnLoad) tabToSet = this.tabOnLoad
        else tabToSet = this.getFirstAvailableTab()
      }

      query.tab = tabToSet
      this.tabIndex = Object.keys(this.tabs).indexOf(tabToSet)

      const tab = find(this.tabs, { key: tabToSet })

      if (this.hasSubTabs) {
        if (!this.$route.query.subtab) {
          query.subtab = tab.defaultSubTab
            ? tab.defaultSubTab
            : Object.keys(this.subTabs[tabToSet])[0]
        }

        this.subTabIndex = Object.keys(this.subTabs[tabToSet]).indexOf(
          query.subtab
        )
        this.$store.commit('setCurrentSubTab', query.subtab)
      } else {
        this.$store.commit('setCurrentSubTab', null)
      }

      this.$router.push({ path: this.$route.path, query })
      this.$store.commit('setCurrentTab', tabToSet)
    },
    setCurrentTab(tabKey) {
      this.additionalView = null
      this.releaseDynamicComponentsData()

      let tabToSet = this.getFirstAvailableTab()

      if (
        find(this.tabs, { key: tabKey }) &&
        (this.$canUpdate || !this.privateTabs.includes(tabKey))
      )
        tabToSet = tabKey
      const query = {
        ...this.$route.query,
        tab: tabToSet,
      }

      this.tabIndex = findIndex(this.tabs, { key: tabKey })

      this.$store.commit('setCurrentTab', tabToSet, tabToSet)
      const template = find(this.tabs, { key: tabToSet })
        ? find(this.tabs, { key: tabToSet }).template || null
        : null
      this.$store.commit('setCurrentTemplate', template)

      delete query.subtab
      this.$store.commit('setCurrentSubTab', null)
      this.$router.push({ path: this.$route.path, query })
    },
    setCurrentSubTab(subTabKey, tabKey) {
      this.additionalView = null
      this.releaseDynamicComponentsData()

      if (tabKey) this.setCurrentTab(tabKey)

      const tab = find(this.tabs, { key: this.currentTab })
      let subTabToSet
      if (subTabKey) {
        subTabToSet = subTabKey
      } else if (!subTabKey && tab.defaultSubTab) {
        subTabToSet = tab.defaultSubTab
      } else if (!subTabKey && !tab.defaultSubTab) {
        subTabToSet = Object.keys(this.subTabs[this.currentTab])[0]
      }
      const query = {
        ...this.$route.query,
        subtab: subTabToSet,
      }

      this.subTabIndex = Object.keys(this.subTabs[this.currentTab]).indexOf(
        subTabToSet
      )

      this.$router.push({ path: this.$route.path, query })
      this.$store.commit('setCurrentSubTab', subTabToSet)
    },
    onTabAdded(tabKey) {
      this.setCurrentTab(tabKey)
    },
    onSubTabAdded(subTabKey, manualTab) {
      if (manualTab) this.setCurrentTab(manualTab)
      this.setCurrentSubTab(subTabKey)
    },
    cacheDashboardSheets() {
      if (!this.widgetsData || !this.widgetsComputed) return
      let scope = {
        ...this.widgetsData,
        ...this.widgetsComputed,
      }
      let scopedData = [
        ...Object.keys(this.widgetsData),
        ...Object.keys(this.widgetsComputed),
      ]
      scopedData.splice(scopedData.indexOf('spreadsheets'), 1)
      scope.scopedData = scopedData

      this.$store.commit('setDashboardSheetsCache', new FormulaCaching(scope))
    },
    rerenderCustomCode() {
      if (this.markupMounted) {
        this.markupMounted = false
        this.$nextTick(() => {
          this.markupMounted = true
        })
      }
    },
    addNewTab(e, template) {
      this.$refs.addTabModal.open(template)
    },
    addNewSubTab(tabKey) {
      eventBus.$emit('showAddSubTabModal', tabKey)
    },
    showTabContextMenu(event) {
      this.isTabContextMenuVisible = true
      this.tabContextMenuPosition.x = event.clientX
      this.tabContextMenuPosition.y = event.clientY
    },
    showSubTabContextMenu(event) {
      this.isSubTabContextMenuVisible = true
      this.subTabContextMenuPosition.x = event.clientX
      this.subTabContextMenuPosition.y = event.clientY
    },
    $getRawDataGridVal(gridId, rowAndCell) {
      const rowAndCellSplited = rowAndCell.split('.')

      if (!rowAndCellSplited[0] || !rowAndCellSplited[1]) {
        console.error(
          `[Table Error]: row and cell address "${rowAndCell}" is invalid`
        )
        return
      }

      const options = this.dataGrid_options[gridId]
      const getModel = db.dataGrid.data.getReadModel(options.storageType)
      const rowKey = rowAndCellSplited[0]
      const cellKey = rowAndCellSplited[1]
      return getModel(`${gridId}.${rowKey}.${cellKey}.value`)
    },
    getDataGridUserVal(cell) {
      const user = _.find(this.userList, { uid: cell.value })
      return user.email
    },
    showSidebar() {
      this.$refs.sidebar.minimizeSidebar()
    },
    hideSidebar(e) {
      if ($(window).width() > 1199) return

      if (
        !$(e.target).closest('.sidebarMobileTrigger').length &&
        !$(e.target).closest('[role="dialog"]').length
      ) {
        this.$refs.sidebar.hide()
      }
    },
    defineFBUser() {
      let userObjects = []

      if (this.dataGrid_options) {
        let grids = Object.values(this.dataGrid_options)

        for (let i = 0; i < grids.length; i++) {
          let gridMeta = (grids[i] || {}).meta

          if (!gridMeta) continue

          for (const key of Object.keys(gridMeta)) {
            if (gridMeta[key].type == 'user') {
              let refObject = { grid: grids[i].source, field: key }
              userObjects.push(refObject)
            }
            // use val
          }
        }

        //console.log('data is loaded', userObjects)
        let userProps = {}
        //loop over user objects and set fb user vals
        for (let i = 0; i < userObjects.length; i++) {
          let m = $getDataGridVals($getGrid(userObjects[i].grid))
          //console.log('m is ', m, userObjects[i].grid)
          let r = m.filter(function(item) {
            return item[userObjects[i].field] == fbUser.email
          })
          fbUser['$' + userObjects[i].grid] = r[0]
        }
      }
    },
    dataGridLogCB(snapshot) {
      if (this.acceptDataGridLogs) {
        //console.log(snapshot.val(),'new log and accept true')
        this.$store.dispatch('dataGrid_update', snapshot.val())
      } else {
        //console.log('new log and set accept true')
        this.acceptDataGridLogs = true
      }
    },
    releaseDynamicComponentsData() {
      window.updateWsName = null
      window.$setFBUserModel = null
      window.$setFBTrackModel = null
      window.$FBUserModel = null
      window.$getUser = null
      window.$setUser = null
      window.$getWorkspaceData = null
      window.$setFBWorkspaceData = null
      window.$sum = null
      window.$computed = null
      window.$setFBDashModel = null
      window.$FBDashModel = null
      window.$FBTrackModels = null
      window.$nflData = null
      window.$profile = null
      window.$profiles = null
      window.$sheets = null
      window.$getPivot = null
      window.getDate = null
      window.onSpreadsheetUpdate = null

      eventBus.$off('onSpreadsheetUpdate')
      db.getRef('dashboardData')
        .child('dashboard')
        .off('value')
      db.accessRef
        .child('workspaceAccess')
        .orderByChild('email')
        .equalTo(fbUser.email)
        .off('value')
    },
  },
  async created() {
    // function imported from './hooks/created.js'
    createdHook.bind(this)()
  },
  beforeDestroy() {
    // function imported from './hooks/beforeDestroy.js'
    beforeDestroyHook.bind(this)()
  },
  beforeRouteEnter(to, from, next) {
    localStorage.setItem('lastDash', to.params.id)
    next()
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';
@import './styles';
</style>
